module.exports = __webpack_public_path__ + "img/search.5580be91.svg";